// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function GoogleLogo2Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 113 38"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M47.875 19.231c0 5.205-4.132 9.04-9.203 9.04-5.07 0-9.203-3.835-9.203-9.04 0-5.242 4.132-9.04 9.203-9.04 5.07 0 9.203 3.798 9.203 9.04zm-4.029 0c0-3.253-2.395-5.478-5.174-5.478-2.78 0-5.174 2.225-5.174 5.478 0 3.22 2.395 5.478 5.174 5.478 2.78 0 5.174-2.262 5.174-5.478zm23.881 0c0 5.205-4.132 9.04-9.202 9.04-5.071 0-9.203-3.835-9.203-9.04 0-5.238 4.132-9.04 9.203-9.04 5.07 0 9.202 3.798 9.202 9.04zm-4.028 0c0-3.253-2.395-5.478-5.174-5.478-2.78 0-5.174 2.225-5.174 5.478 0 3.22 2.394 5.478 5.174 5.478 2.78 0 5.174-2.262 5.174-5.478zm23.054-8.495v16.231c0 6.677-3.995 9.404-8.719 9.404-4.446 0-7.122-2.93-8.131-5.328l3.507-1.438c.625 1.471 2.155 3.207 4.62 3.207 3.024 0 4.897-1.838 4.897-5.298v-1.3h-.14c-.902 1.096-2.64 2.054-4.831 2.054-4.587 0-8.79-3.938-8.79-9.004 0-5.104 4.203-9.074 8.79-9.074 2.188 0 3.925.958 4.83 2.022h.141v-1.471h3.826v-.005zm-3.54 8.528c0-3.184-2.155-5.511-4.897-5.511-2.78 0-5.108 2.327-5.108 5.51 0 3.151 2.328 5.446 5.108 5.446 2.742 0 4.897-2.295 4.897-5.445zM93.06 1.223v26.494h-3.928V1.223h3.929zm15.313 20.983l3.126 2.055c-1.009 1.471-3.441 4.007-7.643 4.007-5.211 0-9.103-3.97-9.103-9.041 0-5.376 3.925-9.04 8.652-9.04 4.761 0 7.089 3.733 7.85 5.75l.418 1.028L99.41 21.97c.939 1.814 2.399 2.74 4.446 2.74 2.051 0 3.474-.995 4.517-2.504zm-9.625-3.252l8.198-3.355c-.451-1.129-1.808-1.916-3.404-1.916-2.048 0-4.897 1.782-4.794 5.27zM14.597 16.88v-3.835h13.116c.128.668.194 1.46.194 2.315 0 2.878-.798 6.436-3.37 8.972-2.503 2.568-5.7 3.937-9.936 3.937-7.85 0-14.45-6.301-14.45-14.038C.15 6.495 6.75.193 14.6.193c4.343 0 7.437 1.68 9.761 3.868l-2.746 2.707c-1.667-1.541-3.925-2.74-7.019-2.74-5.732 0-10.216 4.554-10.216 10.203 0 5.65 4.484 10.202 10.216 10.202 3.719 0 5.836-1.47 7.193-2.808 1.1-1.084 1.824-2.633 2.11-4.748l-9.303.004z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default GoogleLogo2Icon
/* prettier-ignore-end */
